import { AST } from '@handlebars/parser';
import { NodeType } from '../../node/types';
import { DEFAULT_LOCATION as loc } from '../../source/location';
import { formatField } from './formatField';

export const createPathExpression = (
  rawField: string,
  overrides?: Partial<AST.PathExpression>,
): AST.PathExpression => {
  const field = formatField(rawField);
  return {
    type: NodeType.PathExpression,
    data: false,
    depth: 0,
    parts: field.split('.'),
    head: field.split('.')[0],
    tail: field.split('.').slice(1),
    original: field,
    loc,
    ...overrides,
  };
};
